///<reference path='../../typings/index.d.ts' />
///<reference path='pixilayer.ts' />
///<reference path='draggablelayer.ts'/>
///<reference path='../utils/pool.ts' />
///<reference path='../utils/time.ts' />
///<reference path='../utils/spriteutils.ts' />
///<reference path='hiddenobject.ts' />
///<reference path='hogbasescene.ts'/>
///<reference path='splitsprite.ts'/>
///<reference path="../utils/general.ts" />


module agi.expressions.card.layer {

    import Event = agi.expressions.event.Event;
    import DisplacementFilter = PIXI.filters.DisplacementFilter;
    import ObjectType = agi.expressions.card.manifest.ObjectType;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;
    import SpritePool = agi.expressions.card.utils.SpritePool;
    import Stopwatch = agi.expressions.card.utils.Stopwatch;
    import TimeInfo = agi.expressions.card.utils.TimeInfo;
    import Emitter = PIXI.particles.Emitter;
    import TransformUtils = agi.expressions.card.utils.TransformUtils;
    import SpriteUtils = agi.expressions.card.utils.SpriteUtils;
    import SSC = agi.expressions.card.utils.SplitSpriteContainer;
    import GeneralUtils = agi.expressions.card.utils.GeneralUtils;

    export class GameScene extends HOGBaseScene{

        //CONSTANTS
        public OBJS_TO_FIND:number=8;
        public TOTAL_OBJS:number=40;
        public UI_XOFFSET:number=226;
        public UI_YOFFSET:number=630;
        public UI_OBJ_WIDTH:number=102;
        public UI_OBJ_PADDING:number=9.5;

        //Event names
        private EV_NEXT_TRACK = "nextTrack";
        private EV_PLAY_MUSIC = "playMusic";   
        private EV_PLAY_SFX = "playSoundEffect";
        private EV_STOP_MUSIC = "stopMusic";        
        private EV_PAUSE_MUSIC = "pauseMusic";
        private EV_PAUSE_AUDIO_PLAYER = "pauseAudioPlayer"
        private EV_PLAY_CLICKED = "playButtonClicked";
        private EV_INSTRUCTIONS_HIDDEN = "instructionsHidden";
        private EV_GAME_WON = "gameWon";
        private EV_CLOSE_BUTTON = "closeButton";
        private EV_HAS_ORIENTATION_CHANGED = "hasOrientationChanged";

        //SFX names
        

        //containers               
        private uiContainer:PIXI.Container;  
        private bgContainer:PIXI.Container;
        private hogContainer:DraggableLayer;
        private hogScalingContainer:PIXI.Container;
        private objContainer:PIXI.Container;
        private introContainer:PIXI.Container;
        private butterfly_blue:PIXI.Container;
        private butterfly_yellow:PIXI.Container;
        private balloonFrontContainer:PIXI.Container;
        private balloonBackContainer:PIXI.Container;
        private ribbonFrontContainer:PIXI.Container;
        private ribbonBackContainer:PIXI.Container;
        private sparkleContainer:PIXI.Container;
        private flameContainer:PIXI.Container;
        private winContainer:PIXI.Container;
        private bannerContainer:PIXI.Container;
        private frameContainer:PIXI.Container;
        private fountainContainer:PIXI.Container;
        private fountainWater:PIXI.Container;
        private butterflyContainer:PIXI.Container;

        //optimization containers
        private winCopy:PIXI.Container;
        private winCopyText_1:PIXI.Container;
        private winCopyText_2:PIXI.Container;
        
        private tween:TweenMax;
        private alphaTween:TweenLite;
        private uiTween:TweenMax;
        private hogWidth:number;
        private hogHeight:number;
        private bestTime:number=999999999;
        private bestTimeString:string="Play again to see your fastest time!";
        private skipped:boolean=false;
        private isGameOver:boolean=false;

        //arrays
        private objsArray:Array<HiddenObj>=[]; //all hidden objects
        private hiddenArray:Array<HiddenObj>=[]; //the hidden objects that must be found to win
        private leftToFindArray:Array<HiddenObj>=[]; //the remaining hidden objects left to be found
        private uiObjects:Array<PIXI.Sprite>=[];
        private foregroundObjects:Array<PIXI.Sprite>=[];
        private propObjects:Array<PIXI.Sprite>=[];
        private balloonCityArray:Array<PIXI.Sprite>=[];
        private confettiTweenArray:Array<TweenMax>=[];
        private ribbonArray:Array<PIXI.Sprite>=[];

        //sprites
        private uiMenubar:PIXI.Sprite;
        private uiHint:PIXI.Sprite;        
        private uiSkip:PIXI.Sprite;
        private uiInstructions:PIXI.Sprite;
        private uiReplay:PIXI.Sprite;
        private uiBestTimeBG:PIXI.Sprite;
        private instructionBG:PIXI.Sprite;
        private instructionCopy:PIXI.Sprite;
        private hintSprite:PIXI.Sprite;
        private hintCircle:PIXI.Sprite;
        public  cardExitFullscreen: PIXI.Sprite;        
        private frontBalloon:PIXI.Sprite;
        private backBalloon:PIXI.Sprite;
        private frontRibbon:PIXI.Sprite;
        private backRibbon:PIXI.Sprite;
        private uiQuestionMark: PIXI.Graphics;   

        private fountainRipple:PIXI.Texture;
        private fountainShine:PIXI.Texture;
        private rippleTilingLeft:PIXI.extras.TilingSprite;
        private rippleTilingRight:PIXI.extras.TilingSprite;
        private rippleTilingCenter:PIXI.extras.TilingSprite;
        
        private sm_oval_pot:PIXI.Sprite;        
        private flowers_side:PIXI.Sprite;
        private palm_left_1:PIXI.Sprite;
        private palm_left_2:PIXI.Sprite;        
        private palm_left_5:PIXI.Sprite;        
        private purple_flower_1:PIXI.Sprite;
        private purple_flower_2:PIXI.Sprite;

        private butterfly_blue_body:PIXI.Sprite;
        private butterfly_yellow_body:PIXI.Sprite;
        private butterfly_blue_wing1:PIXI.Sprite;
        private butterfly_blue_wing2:PIXI.Sprite;
        private butterfly_yellow_wing1:PIXI.Sprite;
        private butterfly_yellow_wing2:PIXI.Sprite;

        //balloon 
        private randBalloon:PIXI.Sprite;
        private getRandomFrontBalloon:any;
        private getRandomBackBalloon:any;
        private balloonFrontKeys:any;
        private balloonBackKeys:any;

         //ribbon
        private randRibbon:PIXI.Sprite;
        private getRandomFrontRibbon:any;
        private getRandomBackRibbon:any;
        private ribbonFrontKeys:any;
        private ribbonBackKeys:any;

        //text
        private uiStopwatch:PIXI.Text;
        private uiBestTime:PIXI.Text;
        private personalizationText:PIXI.Text;

        //pixi emitters
        private flameConfig:any;
        private flameEmitter_1:Emitter;
        private flameEmitter_2:Emitter;
        private flameEmitter_3:Emitter;

        //movie clips
        private kitty:PIXI.extras.MovieClip;
        private blueButterfly:PIXI.extras.MovieClip;
        private yellowButterfly:PIXI.extras.MovieClip;

        private blueButterflyTimeout:number=1800;
        private yellowButterflyTimeout:number=1800;

        //timelines
        private kittyTL:TimelineMax=new TimelineMax({repeat:-1,repeatDelay:6.166});
        private butterfly_blueTL:TimelineMax=new TimelineMax({repeat:-1,repeatDelay:1.666});
        private butterfly_yellowTL:TimelineMax=new TimelineMax({repeat:-1,repeatDelay:2.25});
        private message:TimelineMax;

        //sprite pools
        private pools : { [index: string] : SpritePool } = {
            "star4": null,
            "star5": null,
            "star6": null
        };

        private balloonBackPools: {[index:string]:SpritePool}={
            "blue_balloon":null,
            "green_balloon":null,
            "orange_balloon":null,
            "pink_balloon":null,
            "purple_balloon":null,
            "teal_balloon":null,
            "yellow_balloon":null,
        };

        private ribbonBackPools: {[index:string]:SpritePool}={
            "ribbon_1":null,
            "ribbon_2":null,
            "ribbon_3":null,
            "ribbon_4":null,
            "ribbon_5":null,
        };

        //hidden objects
        private h01_vase:PIXI.Sprite;

        //Stopwatch
        private stopwatch:Stopwatch;

        /**
         * Essentially synonymous with isMobile
         */
        private hasDeviceOrientation: boolean = false;

        private gameStarted : boolean = false;


        constructor(){
            super();
        }

        public init(options:SceneOptions){


            /**
             * deviceorientation event will not fire immediately, if at all. 
             * Thus, if it does fire and it differs from what was there before, we'll dispatch an event and have the 
             * app update to that. This means any stuff in init that depends on mobile detection should be updated in 
             * addEventBusListeners!
             */
            if ("DeviceOrientationEvent" in window){
                window.addEventListener("deviceorientation", (e) => {
                    let hasDevOrient = e.alpha !== null;                      
                    if (this.hasDeviceOrientation != hasDevOrient)
                        this.eventBus.dispatchEvent(new Event(this.EV_HAS_ORIENTATION_CHANGED, hasDevOrient));
                    this.hasDeviceOrientation = hasDevOrient;   
                });
            }

            super.init(options);


            // ***********************************************
            // sceneContainer
            // The 'stage' for all visual assets of the game.
            // UI and HOG game will go in here.
            // *********************************************** 
            this.sceneContainer = new PIXI.Container();

            // ***********************************************
            // hogContainer
            // Everything that will scale/pan/rotate when
            // multitouching. Put your hidden objects scene in here!
            // ***********************************************

            this.bgContainer=new PIXI.Container();
            SpriteUtils.spriteBuilder("background/bg_",4,this.bgContainer,this);
            //this.bgContainer.width=1280;
            //this.bgContainer.height=720;
            this.bgContainer.interactive=true;
            this.bgContainer.buttonMode=true;
            this.bgContainer.defaultCursor="default";
            
            //assuming bg is the max height and width of the hog scene.
            this.hogWidth=Config.BASE_WIDTH;
            this.hogHeight=Config.BASE_HEIGHT;



            let shadow = PIXI.Sprite.fromFrame("shadow.png"); 
            this.hogScalingContainer = new PIXI.Container();
            this.hogScalingContainer.scale.set(0.5,0.5);
            this.sceneContainer.addChild(this.hogScalingContainer); 

            this.hogContainer = new DraggableLayer(this.bgContainer, this.renderer, this.hogScalingContainer, ()=>Config, {
                sprite: shadow,
                imagePixelPadding: 12,
                padding: 100
            });
            // ***********************************************
            // fountainContainer
            // Water effects
            // ***********************************************
            this.fountainContainer = new PIXI.Container();
            this.fountainWater=new PIXI.Container();
            SpriteUtils.spriteBuilder("fountain/water_",5,this.fountainWater,this.fountainContainer);
            this.fountainWater.position.set(1011,249);

            this.fountainRipple = PIXI.Texture.fromFrame("fountain/ripple.png"); 
            this.fountainShine = PIXI.Texture.fromFrame("fountain/shine.png");            
            this.rippleTilingRight=new PIXI.extras.TilingSprite(this.fountainRipple,463,698);
            this.rippleTilingRight.position.set(1250,249);
            this.rippleTilingRight.tileScale.set(1,4);
            this.rippleTilingLeft=new PIXI.extras.TilingSprite(this.fountainRipple,463,698);
            this.rippleTilingLeft.position.set(1250,249);
            this.rippleTilingLeft.tileScale.set(1,4);
            this.rippleTilingLeft.scale.x=-1;
            this.rippleTilingCenter=new PIXI.extras.TilingSprite(this.fountainShine,463,698);
            this.rippleTilingCenter.position.set(1015,249);
            this.rippleTilingCenter.tileScale.set(2,2);
            this.rippleTilingCenter.alpha=0.5;

            this.fountainContainer.addChild(this.fountainWater,this.rippleTilingLeft,this.rippleTilingRight,this.rippleTilingCenter);
            this.hogContainer.addChildAt(this.fountainContainer,1);

            this.buildFountainSparkle();

            // ***********************************************
            // objContainer
            // All the objects hidden in the scene
            // ***********************************************
            this.objContainer = new PIXI.Container();
            this.buildObjects(this.objContainer, this.foundMe.bind(this), [this.objsArray,this.foregroundObjects, this.propObjects]);
            this.hogContainer.addChild(this.objContainer);
            this.pickObjects();             

            // ***********************************************
            // Palm Leaves Animation
            // Load, pivot, placement, and animations.
            // ***********************************************
            this.tweenForeground(); 
            
            // hint
            this.hintSprite=PIXI.Sprite.fromFrame("particles/glow.png");
            this.hintSprite.hitArea=new PIXI.Rectangle(0,0,0,0);
            this.hintSprite.pivot.set(20,20);
            this.hintSprite.scale.set(.5,.5);
            this.hintSprite.visible=false;
            this.hogContainer.addChild(this.hintSprite);

            this.hintCircle=PIXI.Sprite.fromFrame("UI/hintcircle.png");
            this.hintCircle.pivot.set(70,70);
            this.hintCircle.scale.set(5,5);
            this.hintCircle.visible=false;
            this.hintCircle.hitArea=new PIXI.Rectangle(0,0,0,0);

            var circleMask:PIXI.Graphics=new PIXI.Graphics();
            circleMask.beginFill(0x000000,1);
            circleMask.drawRect(0,0,Config.BASE_WIDTH*2,Config.BASE_WIDTH*2);
            circleMask.endFill();
            this.hogContainer.addChild(circleMask);
            circleMask.hitArea=new PIXI.Rectangle(0,0,0,0);
            this.hintCircle.mask=circleMask;
            this.hogContainer.addChild(this.hintCircle);

            // ***********************************************
            // flameContainer
            // pixi-particles container of flames
            // ***********************************************
            this.flameConfig=this.assetManifest.fireEmitter;
            this.flameContainer=new PIXI.Container();
            this.flameContainer.hitArea=new PIXI.Rectangle(0,0,0,0);

            this.flameEmitter_1 = new Emitter(this.flameContainer,[PIXI.Texture.fromFrame("particles/yellowSparkle.png")],this.flameConfig);
            this.flameEmitter_2 = new Emitter(this.flameContainer,[PIXI.Texture.fromFrame("particles/yellowSparkle.png")],this.flameConfig);
            this.flameEmitter_3 = new Emitter(this.flameContainer,[PIXI.Texture.fromFrame("particles/yellowSparkle.png")],this.flameConfig);

            this.flameEmitter_1.ownerPos.set(1598,588);
            this.flameEmitter_2.ownerPos.set(2153,598);
            this.flameEmitter_3.ownerPos.set(2400,560);

            this.flameEmitter_1.emit=true;
            this.flameEmitter_2.emit=true;
            this.flameEmitter_3.emit=true;
            this.hogContainer.addChild(this.flameContainer);
        

            // ***********************************************
            // sparkleContainer
            // We could have a lot of particles. Let's put em
            // in one place.
            // ***********************************************
            this.sparkleContainer = new PIXI.Container();
            this.hogContainer.addChild(this.sparkleContainer);

            for (let key in this.pools)
                this.pools[key] = new SpritePool(`particles/${key}.png`, 1000, this.sparkleContainer);
            
            // ***********************************************
            // butterflyContainer
            // to hold the animations of the butterflies 
            // ***********************************************
            this.butterflyContainer= new PIXI.Container();
            this.butterflyContainer.hitArea=new PIXI.Rectangle(0,0,0,0);
            this.hogContainer.addChild(this.butterflyContainer);
            this.makeButterflies();

            // ***********************************************
            // frameContainer
            // Just a container that holds the giant frame
            // around the border
            // ***********************************************
            this.frameContainer=new PIXI.Container();
            SpriteUtils.spriteBuilder("UI/frame_",4,this.frameContainer,this.hogContainer);
            this.frameContainer.position.set(-60,-60);
            this.frameContainer.scale.set(2,2);
            this.frameContainer.hitArea=new PIXI.Rectangle(0,0,0,0);

            // ***********************************************
            // winContainer
            // All the end game stuff. Balloons, Happy Birthday,
            // etc.
            // ***********************************************

            this.winContainer=new PIXI.Container();
            this.winContainer.scale.set(2,2);

            //Make the banner
            this.bannerContainer=new PIXI.Container();
            this.winCopy=new PIXI.Container();
            SpriteUtils.spriteBuilder("end/banner",10,this.winCopy,this.bannerContainer);
            
            this.winCopyText_1=new PIXI.Container();
            SpriteUtils.spriteBuilder('end/endcopy1_',6,this.winCopyText_1,this.bannerContainer);
            this.winCopyText_2=new PIXI.Container();
            SpriteUtils.spriteBuilder('end/endcopy2_',6,this.winCopyText_2,this.bannerContainer);

            this.message = new TimelineMax({ onComplete:this.showReplay, onCompleteScope:this });
                this.message.fromTo(this.winCopyText_1,2,{alpha:0},{alpha:1})
                .to(this.winCopyText_1,2,{alpha:0},5)
                .fromTo(this.winCopyText_2,2,{alpha:0},{alpha:1},7);
            this.message.pause(0);

            this.winCopy.interactive=false;
            this.winCopyText_1.interactive=false;
            this.winCopyText_2.interactive=false;

            this.bannerContainer.position.set(83,-200);
            
            this.winCopy.visible=false;
            this.winCopyText_1.visible=false;
            this.winCopyText_2.visible=false;

            //make a set of ribbons in front of the banner
            this.ribbonBackContainer= new PIXI.Container();
            this.winContainer.addChild(this.ribbonBackContainer);
    
            for (let key in this.ribbonBackPools)
                this.ribbonBackPools[key] = new SpritePool(`end/${key}.png`, 100, this.ribbonBackContainer);

            //make balloon in the back of the banner
            this.balloonBackContainer = new PIXI.Container();
            this.winContainer.addChild(this.balloonBackContainer);

            for (let key in this.balloonBackPools)
                this.balloonBackPools[key] = new SpritePool(`end/${key}.png`, 100, this.balloonBackContainer);
            
            this.winContainer.addChild(this.bannerContainer);
       
            //confetti
			for(var m=0;m<60;m++){
				switch(Math.floor(Math.random()*6)){
					case 0: var newConfetti = SpriteUtils.movieClipBuilder("end/confetti_blue",21,0.4,4,1);break;
					case 1: var newConfetti=SpriteUtils.movieClipBuilder("end/confetti_green",21,0.4,4,1);break;
					case 2: var newConfetti=SpriteUtils.movieClipBuilder("end/confetti_red",21,0.4,4,1);break;
                    case 3: var newConfetti=SpriteUtils.movieClipBuilder("end/confetti_pink",21,0.4,4,1);break;
					case 4: var newConfetti=SpriteUtils.movieClipBuilder("end/confetti_orange",21,0.4,4,1);break;
                    default: var newConfetti=SpriteUtils.movieClipBuilder("end/confetti_white",21,0.4,4,1);break;
				}
				
				newConfetti.position.set(Math.random()*Config.BASE_WIDTH,-20);
				if(Math.random()>0.5){
                    this.winContainer.addChild(newConfetti);
                }else{
                    this.winContainer.addChildAt(newConfetti,0);
                }
				newConfetti.animationSpeed=Math.random()*0.2+0.4;
				newConfetti.gotoAndPlay(Math.ceil(Math.random()*21));
				var randoPos:number=(Math.random()*200)-100;
				var waveTween:TweenMax=TweenMax.to(newConfetti,Math.random()+0.5,{x:newConfetti.x+randoPos,yoyo:true,repeat:-1,delay:Math.random()*2,ease:Quad.easeInOut})
				var fallTween:TweenMax=TweenMax.to(newConfetti,3.5+Math.random(),{y:Config.BASE_HEIGHT+20,ease:Linear.easeNone,delay:Math.random()*3,repeat:1});
				this.confettiTweenArray.push(waveTween,fallTween);
				waveTween.pause();
				fallTween.pause();
            }

            this.hogContainer.addChild(this.winContainer);
            this.winContainer.visible=false;

            // ***********************************************
            // uiContainer
            // The menu, copy and all non-scaling objects
            // go in here.
            // *********************************************** 

            //TODO make ui functions to assist with this

            this.uiContainer=new PIXI.Container();
            this.uiMenubar=PIXI.Sprite.fromFrame('UI/menubar.png');            
            this.uiMenubar.position.set(0,571);
            this.uiContainer.addChild(this.uiMenubar);


            /*Regarding question mark bug in Safari only...
                it has been looked into, but am unable to find a solution for either
                A) making question marks go away
                    @see https://github.com/typekit/webfontloader/issues/370
                B) fixing the text positioning of the text after it fixes it self
                    For this, may have to look into PIXI.Text.updateText() - may be a PIXI bug
            */
            this.uiStopwatch = new PIXI.Text("0:00");        
            this.uiStopwatch.style = {font:'22px fusi', fill:'#4b2604'};            
            this.uiStopwatch.position.set(Math.round(83-this.uiStopwatch.width/2), 617);  
            this.uiContainer.addChild(this.uiStopwatch);

            this.uiBestTimeBG=PIXI.Sprite.fromFrame("UI/besttime.png");
            this.uiBestTimeBG.position.set(Math.round(Config.BASE_WIDTH/2-this.uiBestTimeBG.width/2),449);
            this.uiBestTimeBG.visible=false;
            this.uiContainer.addChild(this.uiBestTimeBG);

            this.uiBestTime = new PIXI.Text(this.bestTimeString);
            this.uiBestTime.style = {font:'22px fusi',fill:"#fef0ce"};
            this.uiBestTime.position.set(Math.round(Config.BASE_WIDTH/2-this.uiBestTime.width/2),505);
            this.uiContainer.addChild(this.uiBestTime);
            this.uiBestTime.hitArea=new PIXI.Rectangle(0,0,0,0);

            this.uiHint=PIXI.Sprite.fromFrame("UI/btn_hint.png");
            this.uiHint.position.set(16, 655);
            this.uiHint.interactive=true;
            this.uiHint.buttonMode=true;
            this.uiHint.on('click',this.showHint.bind(this))
            this.uiHint.on('tap',this.showHint.bind(this))
            this.uiContainer.addChild(this.uiHint);

            
            this.uiInstructions=PIXI.Sprite.fromFrame("UI/btn_instructions.png");
            this.uiInstructions.position.set(162, 655);
            this.uiInstructions.interactive=true;
            this.uiInstructions.buttonMode=true;
            this.uiInstructions.on('click', this.onInstructionsDown.bind(this));
            this.uiInstructions.on('tap', this.onInstructionsDown.bind(this));
            this.uiContainer.addChild(this.uiInstructions);

            this.uiReplay=PIXI.Sprite.fromFrame("UI/btn_playagain.png");
            this.uiReplay.position.set(Config.BASE_WIDTH/2-this.uiReplay.width/2,500);
            this.uiReplay.interactive=true;
            this.uiReplay.buttonMode=true;

            let onUiReplayDown = e => {
                this.eventBus.dispatchEvent(new Event(this.EV_STOP_MUSIC, this)); //Need to a force a sound reset since this is just a reset built into gamescene               
                this.reset();
            };

            this.uiReplay.on('click',onUiReplayDown);
            this.uiReplay.on('tap',onUiReplayDown);
            this.uiReplay.visible=false;
            this.uiContainer.addChild(this.uiReplay);            

            this.uiSkip = PIXI.Sprite.fromFrame("UI/btn_skip.png");
            this.uiSkip.position.set(1108, 655);
            this.uiSkip.interactive = true;
            this.uiSkip.buttonMode = true;
            this.uiSkip.on("click", this.skip.bind(this));
            this.uiSkip.on("tap", this.skip.bind(this));
            this.uiContainer.addChild(this.uiSkip);

            this.uiTween=TweenMax.fromTo(this.uiContainer,0.85,{y:150},{y:0});
            this.uiTween.pause();

            this.buildUIObjects();           


            //We need to set a polygonal hitArea to the menuBar so the hogContainer can ignore clicks on them
            let marginTop = 20;
            let lowerUITop = 0.35 * this.uiMenubar.height;
            let uiInstrXOff = -5;
            this.uiMenubar.hitArea = new PIXI.Polygon(0,marginTop,this.uiInstructions.x+uiInstrXOff,marginTop,this.uiInstructions.x+this.uiInstructions.width/2,lowerUITop,
                this.uiMenubar.width,lowerUITop,this.uiMenubar.width,this.uiMenubar.height,0,this.uiMenubar.height,0,marginTop);

            this.sceneContainer.addChild(this.uiContainer);

            //introContainer
            this.introContainer=new PIXI.Container();
            this.introContainer.name="introContainer";

            this.instructionBG=PIXI.Sprite.fromFrame('UI/instructions.png');
            this.introContainer.addChild(this.instructionBG);
            this.instructionBG.interactive=true;
            this.instructionBG.buttonMode=true;
            this.instructionBG.on("click", this.hideInstructions.bind(this));
            this.instructionBG.on("tap", this.hideInstructions.bind(this));  

            this.instructionCopy=PIXI.Sprite.fromFrame('UI/instructions_desktop.png');
            this.introContainer.addChild(this.instructionCopy);
            this.instructionCopy.hitArea=new PIXI.Rectangle(0,0,0,0);

            //kitty
            this.kitty=SpriteUtils.movieClipBuilder("intro/kitty",190,0.4,4,1);
            this.kitty.play();
            this.kitty.pivot.set(63,48)
            this.kitty.position.set(1163,526);
            this.kitty.rotation=0.122173;
            this.kittyTL
                .to(this.kitty,0.75,{rotation:0},2.5)
                .to(this.kitty,0.75,{rotation:0.122173},8.5);
            this.introContainer.addChild(this.kitty);

            //butterflies
            this.buildButterflies();            
            this.sceneContainer.addChild(this.introContainer);

            //Stopwatch
            this.stopwatch = new Stopwatch(false, new TimeInfo(59, 9, 0)); 

            this.addChild(this.sceneContainer);

            this.hogContainer.updateTransform();


            //Public facing card variables
            this.cardExitFullscreen = PIXI.Sprite.fromFrame("UI/exitfullscreen.png");
            this.cardExitFullscreen.pivot.set(this.cardExitFullscreen.width, 0);
            this.cardExitFullscreen.position.set(this.renderer.width-10, 10);
            this.cardExitFullscreen.interactive = true;
            this.cardExitFullscreen.buttonMode = true;

            let onexitdown = () => this.eventBus.dispatchEvent(new Event(this.EV_CLOSE_BUTTON, this));
            this.cardExitFullscreen.on("click", onexitdown);
            this.cardExitFullscreen.on("tap", onexitdown);
            this.sceneContainer.addChild(this.cardExitFullscreen);
            
            this.addEventBusListeners();

            //Prevent zooming or panning until user clicks play button!
            this.hogContainer.setUserInput(false);
        }

        private addEventBusListeners() {

            //Play button is a general event and can encompass other button clicks as well
            //Also note: PlayButton MUST be last because it's the least specific!
            this.eventBus.addEventListener(this.EV_PLAY_CLICKED, (e) => {
                if (e._target instanceof EndReplayButton) {
                    this.reset();
                }
                else if (e._target instanceof PlayButton) {
                    //Music track order is reset after exit full screen button is pressed, so we can just play the current track even if we just hit the replay button
                    this.eventBus.dispatchEvent(new Event(this.EV_PLAY_MUSIC, this));
                }
            });
            this.eventBus.addEventListener(this.EV_INSTRUCTIONS_HIDDEN, e => {
                if (!this.gameStarted)
                    this.eventBus.dispatchEvent(new Event(this.EV_NEXT_TRACK, this));
            });
            this.eventBus.addEventListener(this.EV_GAME_WON, e => {
                this.eventBus.dispatchEvent(new Event(this.EV_NEXT_TRACK, this)); //Will cause to loop back to the first track (ambience) b/c if we've won, we must have been on the last track!
                this.eventBus.dispatchEvent(new Event(this.EV_PLAY_SFX, "Finding_Game_V3_Ending"));
            });
            this.eventBus.addEventListener(this.EV_HAS_ORIENTATION_CHANGED, e => {
                //And logic changes / asset swapping that would ideally need to be done at init should be done here.
                this.instructionCopy.texture=PIXI.Texture.fromFrame("UI/instructions_mobile.png");
            });
        }

        private tweenForeground(){
            //TODO: make list instead
            let palm_left_1 = <PIXI.Sprite>this.objContainer.getChildByName("palm_left_1");
            let palm_left_2 = <PIXI.Sprite>this.objContainer.getChildByName("palm_left_2");
            let palm_left_3 = <PIXI.Sprite>this.objContainer.getChildByName("palm_left_3");
            let palm_left_4 = <PIXI.Sprite>this.objContainer.getChildByName("palm_left_4");
            let palm_left_5 = <PIXI.Sprite>this.objContainer.getChildByName("palm_left_5");
            let palm_right_1 = <PIXI.Sprite>this.objContainer.getChildByName("palm_right_1");
            let palm_right_2 = <PIXI.Sprite>this.objContainer.getChildByName("palm_right_2");
            let palm_right_3 = <PIXI.Sprite>this.objContainer.getChildByName("palm_right_3");
            let flowers_branch = <PIXI.Sprite>this.objContainer.getChildByName("flowers-branch");

            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(0,246), palm_left_1);
            TweenMax.to(palm_left_1,1.5,{
                yoyo:true,
                repeat:-1,
                rotation:-0.02,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-1.5
            });

            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(0,246), palm_left_2);
            TweenMax.to(palm_left_2,3,{
                yoyo:true,
                repeat:-1,
                rotation:-0.05,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
            });
            
            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(0,246), palm_left_3);            
            TweenMax.to(palm_left_3,2,{
                yoyo:true,
                repeat:-1,
                rotation:-0.06,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-1.5
            });

            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(0,246), palm_left_4);            
            TweenMax.to(palm_left_4,3,{
                yoyo:true,
                repeat:-1,
                rotation:-0.07,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-1
            });

            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(0,246), palm_left_5);            
            TweenMax.to(palm_left_5,2.5,{
                yoyo:true,
                repeat:-1,
                rotation:-0.08,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-.5
            });


            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(282,150), palm_right_1);            
            TweenMax.to(palm_right_1,2.3,{
                yoyo:true,
                repeat:-1,
                rotation:0.07,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-.3
            });

    
            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(282,150), flowers_branch);                       
            TweenMax.to(flowers_branch,2.3,{
                yoyo:true,
                repeat:-1,
                rotation:0.07,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-.3
            });

            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(282,150), palm_right_2);                                    
            TweenMax.to(palm_right_2,4.5,{
                yoyo:true,
                repeat:-1,
                rotation:0.1,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-1.2
            });

            TransformUtils.setPivotAndMaintainVisualPosition(new PIXI.Point(282,150), palm_right_3);                                    

            TweenMax.to(palm_right_3,3.5,{
                yoyo:true,
                repeat:-1,
                rotation:0.2,
                ease:Sine.easeInOut,
                yoyoEase:Sine.easeInOut,
                delay:-1.2
            });


            //set the moving objects on the corner graphics
            //group one - clarinet, microphone, key
            if (this.configIndex == 0){
                // clarinet
                var clarinet = this.objContainer.getChildByName("flute");
                TransformUtils.addChildAndMaintainVisualPosition(palm_left_3, clarinet);
                clarinet.rotation=3.9;
                clarinet.scale.set(1.2,1.2);
                
                // microphone
                var mic = this.objContainer.getChildByName("microphone");
                TransformUtils.addChildAndMaintainVisualPosition(palm_right_1, mic);

                // key
                var key = this.objContainer.getChildByName("key");
                TransformUtils.addChildAndMaintainVisualPosition(palm_right_1, key);  
            }

            //group two - binoculars, umbrella, watch
            if (this.configIndex == 1){
                // binoculars
                var binoculars = this.objContainer.getChildByName("binoculars");
                TransformUtils.addChildAndMaintainVisualPosition(palm_left_4, binoculars); 
                
                // umbrella
                var umbrella = this.objContainer.getChildByName("umbrella");
                TransformUtils.addChildAndMaintainVisualPosition(palm_left_3,umbrella);
                umbrella.rotation=0.785;

                // watch
                var watch = this.objContainer.getChildByName("silver-watch");
                TransformUtils.addChildAndMaintainVisualPosition(flowers_branch, watch); 
            }
                  
        }

        private unhideObjects(){
            for(var i=0;i<this.hiddenArray.length; i++){
                var aHiddenObj:HiddenObj=this.hiddenArray[i];
                aHiddenObj.visible = true;
                aHiddenObj.fadeTL.kill();

                aHiddenObj.hideSprite.alpha = 1;
                aHiddenObj.hideSprite.visible = true;

                //This must be invisible so it does not block the interactions with the hideSprite. Just setting alpha to zero will not work.
                aHiddenObj.foundSprite.visible = false;
                aHiddenObj.foundSprite.alpha = 1;
                //Reset blur filter if one exists
                if (aHiddenObj.foundSprite.filters && aHiddenObj.foundSprite.filters.length > 0){
                    let blurFilter : any = aHiddenObj.foundSprite.filters[0];
                    blurFilter.blurXFilter.strength = 0;
                    blurFilter.blurYFilter.strength = 0;
                }
            }
        }

        /**
         * Invoked when the ? button is pressed.
         */
        private onInstructionsDown(){
            this.introContainer.visible = true;
            TweenMax.to(this.introContainer, 0.5, {alpha: 1});
            this.hogContainer.setUserInput(false);
            this.hogContainer.detectEdges();
            this.stopwatch.stop();
        }

        private pickObjects(){
            // Pick OBS_TO_FIND objects as the "hidden" objects for our game.
            // Set isHidden to be true, push to hiddenArray.
            for(var i=0; i<this.OBJS_TO_FIND; i++){
                do{ 
                    var aObj:HiddenObj=this.objsArray[Math.floor(Math.random()*this.objsArray.length)];
                }while(aObj.isHidden);
                aObj.isHidden=true;

                this.hiddenArray.push(aObj);
                this.leftToFindArray.push(aObj); 

                var hitAreaPadding = 30;
                aObj.hideSprite.hitArea = new PIXI.Rectangle(-hitAreaPadding, -hitAreaPadding, aObj.hideSprite.width + hitAreaPadding*2, aObj.hideSprite.height + hitAreaPadding*2);
            }
        }

        private buildUIObjects(){
            for(var i=0; i<this.OBJS_TO_FIND; i++){
                var aName=this.hiddenArray[i].name.toString();
                var aUIObj=PIXI.Sprite.fromFrame("UI/objects/"+aName+this.assetManifest.objectFileExt);
                aUIObj.x=this.UI_XOFFSET+this.UI_OBJ_WIDTH*i+this.UI_OBJ_PADDING*i;
                aUIObj.y=this.UI_YOFFSET;
                this.uiContainer.addChildAt(aUIObj,1);
                this.uiObjects.push(aUIObj);
            }
        }

        private buildFountainSparkle(){
            var i=0;
            this.assetManifest.fountain.forEach(function(element){
                var newClip:PIXI.extras.MovieClip=SpriteUtils.movieClipBuilder("fountain/sparkle",20,0.4,1,0);
                newClip.position=this.assetManifest.fountain[i][0];
                newClip.scale=this.assetManifest.fountain[i][1];
                newClip.gotoAndPlay(Math.round(Math.random()*9)+1);
                newClip.play();
                this.hogContainer.addChild(newClip);
                i++;
            }.bind(this));            
        }

        private buildButterflies(){
            this.butterfly_blue=new PIXI.Container();
            this.butterfly_blue_body=PIXI.Sprite.fromFrame("intro/butterfly_blue_body.png");
            this.butterfly_blue_wing1=PIXI.Sprite.fromFrame("intro/butterfly_blue_wing.png");
            this.butterfly_blue_wing2=PIXI.Sprite.fromFrame("intro/butterfly_blue_wing.png");
            this.butterfly_blue_body.position.set(10,90);
            this.butterfly_blue_wing1.pivot.set(60,100);
            this.butterfly_blue_wing2.pivot.set(60,100);
            this.butterfly_blue_wing1.position.set(65,100);
            this.butterfly_blue_wing2.position.set(65,108);
            this.butterfly_blue_wing2.scale.y=-1;
            this.butterfly_blue.addChild(this.butterfly_blue_body,this.butterfly_blue_wing1,this.butterfly_blue_wing2);
            this.introContainer.addChild(this.butterfly_blue);
            this.butterfly_blue.pivot.set(50,103);
            this.butterfly_blue.scale.set(0.5,0.5);
            this.butterfly_blue.position.set(59,193);
            this.butterfly_blue.rotation=-0.77300633;

            this.butterfly_yellow=new PIXI.Container();
            this.butterfly_yellow_body=PIXI.Sprite.fromFrame("intro/butterfly_yellow_body.png");
            this.butterfly_yellow_wing1=PIXI.Sprite.fromFrame("intro/butterfly_yellow_wing.png");
            this.butterfly_yellow_wing2=PIXI.Sprite.fromFrame("intro/butterfly_yellow_wing.png");
            this.butterfly_yellow_body.position.set(0,45);
            this.butterfly_yellow_wing1.pivot.set(35,50);
            this.butterfly_yellow_wing2.pivot.set(35,50);
            this.butterfly_yellow_wing1.position.set(34,50);
            this.butterfly_yellow_wing2.position.set(34,57);
            this.butterfly_yellow_wing2.scale.y=-1;
            this.butterfly_yellow.addChild(this.butterfly_yellow_body,this.butterfly_yellow_wing1,this.butterfly_yellow_wing2);
            this.introContainer.addChild(this.butterfly_yellow);
            this.butterfly_yellow.pivot.set(33,54);
            this.butterfly_yellow.scale.set(0.5,0.5);
            this.butterfly_yellow.position.set(1197,212);
            this.butterfly_yellow.rotation=-2.32268417;

            this.butterfly_blueTL
                .to(this.butterfly_blue_wing1,0.166,{pixi:{scaleY:1.04}},0)
                .to(this.butterfly_blue_wing2,0.166,{pixi:{scaleY:-1.04}},0)
                .to(this.butterfly_blue_wing1,0.25,{pixi:{scaleY:0.724}},0.166)
                .to(this.butterfly_blue_wing2,0.25,{pixi:{scaleY:-0.724}},0.166)
                .to(this.butterfly_blue_wing1,0.25,{pixi:{scaleY:1.04}},0.416)
                .to(this.butterfly_blue_wing2,0.25,{pixi:{scaleY:-1.04}},0.416)
                .to(this.butterfly_blue_wing1,0.166,{pixi:{scaleY:1}},0.666)
                .to(this.butterfly_blue_wing2,0.166,{pixi:{scaleY:-1}},0.666)

                .to(this.butterfly_blue_wing1,0.166,{pixi:{scaleY:1.04}},1.666)
                .to(this.butterfly_blue_wing2,0.166,{pixi:{scaleY:-1.04}},1.666)
                .to(this.butterfly_blue_wing1,0.208,{pixi:{scaleY:0.724}},1.832)
                .to(this.butterfly_blue_wing2,0.208,{pixi:{scaleY:-0.724}},1.832)
                .to(this.butterfly_blue_wing1,0.208,{pixi:{scaleY:1.04}},2.04)
                .to(this.butterfly_blue_wing2,0.208,{pixi:{scaleY:-1.04}},2.04)
                .to(this.butterfly_blue_wing1,0.125,{pixi:{scaleY:1}},2.248)
                .to(this.butterfly_blue_wing2,0.125,{pixi:{scaleY:-1}},2.248)
                .to(this.butterfly_blue_wing1,0.125,{pixi:{scaleY:1.04}},2.373)
                .to(this.butterfly_blue_wing2,0.125,{pixi:{scaleY:-1.04}},2.373)
                .to(this.butterfly_blue_wing1,0.208,{pixi:{scaleY:0.724}},2.498)
                .to(this.butterfly_blue_wing2,0.208,{pixi:{scaleY:-0.724}},2.498)
                .to(this.butterfly_blue_wing1,0.208,{pixi:{scaleY:1.04}},2.706)
                .to(this.butterfly_blue_wing2,0.208,{pixi:{scaleY:-1.04}},2.706)
                .to(this.butterfly_blue_wing1,0.125,{pixi:{scaleY:1}},2.914)
                .to(this.butterfly_blue_wing2,0.125,{pixi:{scaleY:-1}},2.914)
            ;
            
            this.butterfly_yellowTL
                .to(this.butterfly_yellow_wing1,0.166,{pixi:{scaleY:1.04}},1)
                .to(this.butterfly_yellow_wing2,0.166,{pixi:{scaleY:-1.04}},1)
                .to(this.butterfly_yellow_wing1,0.25,{pixi:{scaleY:0.724}},1.166)
                .to(this.butterfly_yellow_wing2,0.25,{pixi:{scaleY:-0.724}},1.166)
                .to(this.butterfly_yellow_wing1,0.25,{pixi:{scaleY:1.04}},1.416)
                .to(this.butterfly_yellow_wing2,0.25,{pixi:{scaleY:-1.04}},1.416)
                .to(this.butterfly_yellow_wing1,0.166,{pixi:{scaleY:1}},1.666)
                .to(this.butterfly_yellow_wing2,0.166,{pixi:{scaleY:-1}},1.666)

                .to(this.butterfly_yellow_wing1,0.166,{pixi:{scaleY:1.04}},2.666)
                .to(this.butterfly_yellow_wing2,0.166,{pixi:{scaleY:-1.04}},2.666)
                .to(this.butterfly_yellow_wing1,0.208,{pixi:{scaleY:0.724}},2.832)
                .to(this.butterfly_yellow_wing2,0.208,{pixi:{scaleY:-0.724}},2.832)
                .to(this.butterfly_yellow_wing1,0.208,{pixi:{scaleY:1.04}},3.04)
                .to(this.butterfly_yellow_wing2,0.208,{pixi:{scaleY:-1.04}},3.04)
                .to(this.butterfly_yellow_wing1,0.125,{pixi:{scaleY:1}},3.248)
                .to(this.butterfly_yellow_wing2,0.125,{pixi:{scaleY:-1}},3.248)
                .to(this.butterfly_yellow_wing1,0.125,{pixi:{scaleY:1.04}},3.373)
                .to(this.butterfly_yellow_wing2,0.125,{pixi:{scaleY:-1.04}},3.373)
                .to(this.butterfly_yellow_wing1,0.208,{pixi:{scaleY:0.724}},3.498)
                .to(this.butterfly_yellow_wing2,0.208,{pixi:{scaleY:-0.724}},3.498)
                .to(this.butterfly_yellow_wing1,0.208,{pixi:{scaleY:1.04}},3.706)
                .to(this.butterfly_yellow_wing2,0.208,{pixi:{scaleY:-1.04}},3.706)
                .to(this.butterfly_yellow_wing1,0.125,{pixi:{scaleY:1}},3.914)
                .to(this.butterfly_yellow_wing2,0.125,{pixi:{scaleY:-1}},3.914)
            ;

        }

        private makeButterflies(){
               //blue butterfly
               this.blueButterfly=SpriteUtils.movieClipBuilder("butterflies/blue/blue", 371,.4,4,1);
               this.blueButterfly.animationSpeed=.25;
               this.blueButterfly.gotoAndPlay(0);
               this.blueButterfly.position.set(-185,100);
               this.butterflyContainer.addChild(this.blueButterfly);
   
               //yellow butterfly 
               this.yellowButterfly=SpriteUtils.movieClipBuilder("butterflies/orange/orange", 246,.4,4,1);
               this.yellowButterfly.animationSpeed=0.25;
               this.yellowButterfly.gotoAndPlay(0);
               this.yellowButterfly.position.set(-50,200);
               this.butterflyContainer.addChild(this.yellowButterfly);
        }

        private onInstrComplete(){
            this.introContainer.visible=false;
            this.hogContainer.setUserInput(true);
            this.eventBus.dispatchEvent(new Event(this.EV_INSTRUCTIONS_HIDDEN, this));            
            this.gameStarted = true;            
        }

        private hideInstructions(e:Event){
            if(this.introContainer.alpha==1){
                TweenMax.to(this.introContainer,0.5,{
                    alpha:0,
                    //onComplete:function(){this.introContainer.visible=false}.bind(this)
                    onComplete:this.onInstrComplete.bind(this),
                })
                //start the clock!
                this.stopwatch.start();
                this.uiContainer.visible=true;
                this.uiBestTime.visible=false;
                this.uiBestTimeBG.visible=false;
                this.uiTween.play(0);

                //reset the butterflies back to the beginning
                this.blueButterfly.gotoAndPlay(0);
                this.yellowButterfly.gotoAndPlay(0);
            }
            
        }
       
        private foundMe(e:any){
            if (this.hogContainer.getDelayedIsPanning())
                return;
            var aSprite = e.target;
            // check to see if object is "hidden"
            if(aSprite.parent.isHidden){
                // make disappear prevent from happening multiple times.
                // aSprite is only at 100% alpha if animation hasn't begun.

                if(aSprite.alpha==1){   
                    this.eventBus.dispatchEvent(new Event(this.EV_PLAY_SFX, "Finding_Game_SFX_Short"));
                    
                    aSprite.parent.foundSprite.visible=true;   
                    aSprite.parent.fadeTL=new TimelineMax({
                        onComplete:this.foundOver,
                        onCompleteScope:this,
                        onCompleteParams:[e.target],
                        onUpdate:this.makeSparkle,
                        onUpdateScope:this,
                        onUpdateParams:[aSprite], //Make sure this is aSprite, not aSprite.parent, as makeSparkle checks for alpha for particle lifetime, and parent's alpha doesn't change
                    });
                    aSprite.parent.fadeTL
                        .from(aSprite.parent.foundSprite,0.5,{alpha:0,ease:Power0.easeNone})
                        .to(aSprite.parent.foundSprite,1,{alpha:0})                        
                        .to(aSprite,1.6,{alpha:0},0)
                        .to(aSprite.parent.foundSprite,1,{pixi:{blur:30}},0);
                }
                
                aSprite.parent.isHidden=false;

                //"gray out" on UI
                TweenLite.to(this.uiObjects[this.hiddenArray.indexOf(aSprite.parent)],0.35,{alpha:0.2});
                
                this.hideHint();
                this.leftToFindArray.splice(this.leftToFindArray.indexOf(aSprite.parent),1);


                //check to see if it's the last object - if so, you WIN!
                if(this.leftToFindArray.length==0){
                    this.youWin();
                }
            }
        }

        private youWin(){
            if(!this.isGameOver){
                this.isGameOver=true;
          
                this.uiTween.reverse(0);

                //call the end celebration methods
                this.bannerMovement();
                this.confettiFall();
                this.ribbonsFall();
                this.makeBalloons();

            //console.log("YOU WIN!!!!");
            this.stopwatch.stop();
            this.hideHint();
            this.zoomOutScene();

            this.checkBestTime();

            this.eventBus.dispatchEvent(new Event(this.EV_GAME_WON, this));

            //hide all the objects, cheater
            //We can't have all the hidden objects in a container because of layering with non-hidden objects, so we'll have to go through the array
            this.objsArray.forEach(hObj => {
                TweenLite.to(hObj, 1, {alpha:0});
                hObj.interactiveChildren = false;
            });

            //disable pan/zoom
            this.hogContainer.setUserInput(false);
            }
        }

        private bannerMovement(){
            //bring down the banner copy
            this.winCopy.visible=true;
            TweenLite.to(this.bannerContainer,1,{
                y:115,
                ease:Power2.easeOut,    
                onComplete:this.showBirthdayMessage,
                onCompleteScope:this
            });

            this.winContainer.visible=true;
        }

        private showBirthdayMessage(){
            this.winCopyText_1.visible=true;
            this.winCopyText_2.visible=true;
            this.message.play(0);
        }

        private zoomOutScene(){
            this.hogContainer.zoomOut();
        }

        private showHint(e:MouseEvent){
            if((this.leftToFindArray.length>0)&&(!TweenMax.isTweening(this.hintSprite))){  
                this.zoomOutScene();

                this.hintSprite.visible=true;
                TweenMax.killTweensOf(this.hintSprite);

                // pick a position
                var aLoc=this.leftToFindArray[0];

                var R = 700; 

                //Set the hint sprite's position to the global target object's position transformed to be local to hintSprite's parent - as PIXI's positions are local to their parent!
                this.hintSprite.position.copy(this.hintSprite.parent.toLocal(aLoc.parent.toGlobal(aLoc.position)));

                //slightly off-center the hint, make it difficult :D
                this.hintSprite.x+=Math.random()*(R/4)-(R/4);
                this.hintSprite.y+=Math.random()*(R/4)-(R/4);

                //add the hint circle
                this.hintCircle.position.copy(this.hintSprite.position);
                this.hintCircle.visible=true;

                TweenMax.killTweensOf(this.hintCircle);

                TweenMax.fromTo(this.hintCircle,1.25,{alpha:0},{alpha:1,repeat:7,yoyo:true,ease:Power2.easeInOut});
                TweenMax.fromTo(this.hintCircle,2.5,{pixi:{scaleX:5,scaleY:5}},{pixi:{scaleX:5.4,scaleY:5.4},ease:Back.easeOut,repeat:3});

                var hintPos:PIXI.Point=this.hintSprite.position;
                //circle positions
                var positions=[
                    {x:hintPos.x,y:hintPos.y-(R/2)},
                    {x:hintPos.x-(R/2),y:hintPos.y},
                     {x:hintPos.x,y:hintPos.y+(R/2)},
                    {x:hintPos.x+(R/2),y:hintPos.y},
                    {x:hintPos.x,y:hintPos.y-(R/2)}
                ];
                //start at the top
                this.hintSprite.y-=(R/2);

                //which side of the screen is the hint on?
                if(hintPos.x<Config.BASE_WIDTH){
                    //make clockwise
                    positions.reverse();
                } 
                //tween
                TweenMax.to(this.hintSprite, 2.5,{
                    bezier:{curviness:1.6,values:positions},
                    ease:Power0.easeNone,
                    repeat:2,
                    onUpdate:this.makeSparkle,
                    onUpdateScope:this,
                    onUpdateParams:[this.hintSprite],
                    onComplete:this.hideHint,
                    onCompleteScope:this
                });              
            }
        }

        private hideHint(){
            this.hintSprite.visible=false;
            TweenMax.killTweensOf(this.hintSprite);
            TweenMax.killTweensOf(this.hintCircle);
            this.hintCircle.visible=false;
        }

        private isInBounds(aTarg:PIXI.Sprite){
            if((aTarg.x>0)&&(aTarg.y>0)&&(aTarg.x<Config.BASE_WIDTH*2)&&(aTarg.y<Config.BASE_HEIGHT*2)){
                return true;
            }else{
                return false;
            }
        }

        private makeSparkle(aSprite:PIXI.Sprite){
            aSprite.visible=this.isInBounds(aSprite);
            if((aSprite.alpha>0.7)&&(this.isInBounds(aSprite))){
                //create a sparkle
                var newStarFour=this.pools["star4"].newSprite();
                var newStarFive=this.pools["star5"].newSprite();
                var newStarSix=this.pools["star6"].newSprite();

                var starArray:Array<PIXI.Sprite>=[newStarFour,newStarFive,newStarSix];
                var poolArray:Array<any>=[this.pools["star4"],this.pools["star5"],this.pools["star6"]];

                //Make sure the width and height we're using is relative to sparkleContainer!
                let bounds = aSprite.getBounds();
                let globalBounds = new PIXI.Point(bounds.width, bounds.height);
                let localBounds = TransformUtils.inverseTransformDirection(globalBounds, this.sparkleContainer.worldTransform);
                for(var i=0;i<3;i++){
                    //find a random point in a circle
                    var xPos=Math.random()+0.2;
                    var yPos=Math.random()+0.2;
                    var randScale=Math.random()+0.5;

                    //random position
                    let globalPos = aSprite.parent.toGlobal(aSprite.position);
                    let targetPos = this.sparkleContainer.toLocal(globalPos);
                    var randPosX=targetPos.x+yPos*(localBounds.x/2)*Math.cos(2*Math.PI*xPos/yPos);
                    var randPosY=targetPos.y+yPos*(localBounds.y/2)*Math.sin(2*Math.PI*xPos/yPos);
                    starArray[i].x=randPosX;
                    starArray[i].y=randPosY;

                    //random scale and rotation
                    starArray[i].scale.set((i+5)/10*randScale,(i+5)/10*randScale);
                    starArray[i].rotation=Math.random()*6.25;

                    //tween
                    TweenLite.to(starArray[i],2+Math.random(),{
                        rotation:'+='+Math.random()*(12.5-6.25),
                        x:"+="+((randPosX-targetPos.x)),
                        y:"+="+((randPosY-targetPos.y)),
                        width:0,
                        height:0,
                        onComplete:this.sparkleRemove,
                        onCompleteParams:[starArray[i], poolArray[i]],
                        onCompleteScope:this
                    });
                }
            }

        }

        private makeBalloons(){
            //create the new balloons
            //make an array of the keys to the balloonPools object,
            this.balloonBackKeys= Object.keys(this.balloonBackPools);

            //make a balloon party
            for (var i = 0; i<120; i++){

                //back balloons
                //get a new sprite from a random sprite pool
                this.getRandomBackBalloon = this.balloonBackKeys[Math.floor(Math.random()*this.balloonBackKeys.length)];
                this.backBalloon= this.balloonBackPools[this.getRandomBackBalloon].newSprite();

                //make random positions
                var xPos=GeneralUtils.getRandomNumber(-200, 1550);
                var yPos=800;
                var randoPos=GeneralUtils.getRandomNumber(-50,50);
                var randoyEnd=GeneralUtils.getRandomNumber(-250,-100);
                var randoDelay= Math.random()*4.5;
 
                this.backBalloon.x=xPos;
                this.backBalloon.y=yPos;

                //var frontTargetxPos = this.frontBalloon.x + randoPos;
                var backTargetxPos = this.backBalloon.x + randoPos;

                // rise back tween
                TweenMax.fromTo(this.backBalloon, 6.5+(Math.random()* 1.05), {y:yPos}, {y:(-655+-randoyEnd), 
                    ease: Power1.easeIn,
                    delay:randoDelay,        
                    onComplete:this.balloonBackRemove,
                    onCompleteParams:[this.backBalloon, 
                    this.balloonBackPools[this.getRandomBackBalloon]],
                    onCompleteScope:this});

                // wiggle back tween
                TweenMax.to(this.backBalloon,1.5+(Math.random()* .02),{
                    x:backTargetxPos,
                    ease:Sine.easeInOut,
                    yoyoease:Sine.easeInOut,
                    yoyo:true,
                    repeat:-1,
                    delay:Math.random()*2
                });

                //add the baloons to the array
                this.balloonCityArray.push(this.backBalloon);
            }

        }

        private ribbonsFall(){
            //create the ribbons
            //make an array of the keys to the ribbonPools object,
            this.ribbonBackKeys= Object.keys(this.ribbonBackPools);

            //make a ribbon party
            for (var i = 0; i<80; i++){
                //get a new sprite from a random sprite pool

                // back ribbons
                //get a new sprite from a random sprite pool
                this.getRandomBackRibbon = this.ribbonBackKeys[Math.floor(Math.random()*this.ribbonBackKeys.length)];
                this.backRibbon= this.ribbonBackPools[this.getRandomBackRibbon].newSprite();

                //make random positions
                var xPos=GeneralUtils.getRandomNumber(-100, 1450);
                var yPos=-150;
                var randoyEnd=GeneralUtils.getRandomNumber(100,150);
                var randoDelay= Math.random()*5;
 
                //set random position
                this.backRibbon.x=xPos;
                this.backRibbon.y=yPos;
        
                // fall back tween
                TweenMax.fromTo(this.backRibbon, 6.5+(Math.random()* 1.03), {y:yPos}, {y:(1220+-randoyEnd), 
                    ease: Power1.easeInOut,
                    rotation:'+='+Math.random()*(12.5-6.25),
                    delay:randoDelay,
                    onComplete:this.ribbonBackRemove,
                    onCompleteParams:[this.backRibbon, 
                    this.ribbonBackPools[this.getRandomBackRibbon]],
                    onCompleteScope:this});
                
                // rotate front tween
                TweenMax.to(this.backRibbon, 1.5 +(Math.random()* .02), { 
                    rotation:'+='+Math.random()*(12.5-6.25),
                  });
                
                //this.ribbonArray.push(this.frontRibbon);
                this.ribbonArray.push(this.backRibbon);
            }
        }

        //make confetti fall
		public confettiFall(){
			//loop thru confetti tweens and play them.
			for(var i=0;i<this.confettiTweenArray.length;i++){				
				this.confettiTweenArray[i].restart(true);
			}
		}

		//reset confetti
		public confettiReset(){
			//loop thru confetti tweens and pause them at 0:00.
			for(var i=0;i<this.confettiTweenArray.length;i++){				
				this.confettiTweenArray[i].pause(0);
			}
		}

        private foundOver(aSprite:PIXI.Sprite){
            aSprite.parent.visible=false;
        }

        public sparkleRemove(aSparkle:PIXI.Sprite, pool:SpritePool){
            pool.retireSprite(aSparkle);
        }

        public ribbonBackRemove(backRibbon:PIXI.Sprite, ribbonBackPools:SpritePool){
            ribbonBackPools.retireSprite(backRibbon);
        }

        private balloonBackRemove(backBalloon:PIXI.Sprite, balloonBackPools:SpritePool){
            balloonBackPools.retireSprite(backBalloon);
        }

        private checkBestTime(){
            if(!this.skipped){
                var yourTime=this.stopwatch.getCurrentTime().getTimeInSeconds();
                if(yourTime<this.bestTime){
                    this.bestTime=yourTime;
                    this.bestTimeString = "Want to beat your time of "+this.stopwatch.getCurrentTime().toString(TimeInfo.MINUTES | TimeInfo.SECONDS, ":", false)+"?";
                }
            }
        }
        
        private showReplay(){
            this.uiReplay.visible=true;
            this.uiBestTime.visible=true;
            this.uiBestTimeBG.visible=true;
            TweenLite.fromTo(this.uiBestTime,1,{alpha:0},{alpha:1, delay:0.6});
            TweenLite.fromTo(this.uiBestTimeBG,1,{alpha:0},{alpha:1, delay:0.6});
            TweenLite.fromTo(this.uiReplay,1,{alpha:0},{alpha:1, delay:1});
            this.uiBestTime.text=this.bestTimeString;
            this.uiBestTime.style = {font:'22.5px fusi',fill:"#fef0ce",letterSpacing:1};
            this.uiBestTime.position.set(Math.round(Config.BASE_WIDTH/2-this.uiBestTime.width/2),455);
        }


        public transition() {
            this.visible = true;
            this.alpha = 0;
            if (this.personalizations.nameData){
                this.personalizationText.text = this.personalizations.nameData;
            }
            this.alphaTween.restart();
        }

        /**
        * Reset the game
        */
        public reset(){
            this.hogContainer.reset();
            this.hideHint();
            //this.unhideObjects() is no longer necessary here as we're getting rid of objContainer's children and replacing them with brand new sprites.

            //Clear out these arrays
            this.hiddenArray=[];
            this.leftToFindArray=[];

            //Remove all the objects from the object container - these will be replaced as we're going to pick a brand new level configuration
            while (this.objContainer.children.length > 0){
                this.objContainer.removeChildAt(0);
            }
            //Clear out the arrays of objects, props, and foreground objects so all references to old objects go away
            this.objsArray.splice(0); 
            this.foregroundObjects.splice(0);
            this.propObjects.splice(0);
            //Pick a new object configuration and add everything to the scene
            this.buildObjects(this.objContainer, this.foundMe.bind(this), [this.objsArray,this.foregroundObjects, this.propObjects]);
            
            this.message.pause(0);

            this.tweenForeground(); //Tell all the new leaves that they need to tween, and attach appropriate hidden objects to them
            
            //reset the butterflies back to the beginning
            this.blueButterfly.stop();
            this.yellowButterfly.stop();

            this.pickObjects(); 
            //Remove ui elements because we'll rebuild them shortly
            this.uiObjects.forEach(function(element){
                this.uiContainer.removeChild(element);
            }.bind(this));
            this.uiObjects = [];
            this.buildUIObjects();
            //And finally reset the stopwatch
            this.stopwatch.reset();

            //this.zoomOutScene();
            this.introContainer.visible=true;
            TweenMax.to(this.introContainer,0.5,{alpha:1});
            this.uiContainer.visible=false;
            
            this.winCopy.visible=false;
            this.bannerContainer.position.y=-200;
            this.winCopyText_1.visible=false;
            this.winCopyText_2.visible=false;
            this.confettiReset();

            //ribbon reset
            for(let key in this.ribbonBackPools){
                this.ribbonBackPools[key].retireAllSprites();
            }
            for(var ribbon in this.ribbonArray){
                TweenMax.killTweensOf(this.ribbonArray[ribbon]);
            }

            //balloon removal
            for(let key in this.balloonBackPools){
                this.balloonBackPools[key].retireAllSprites();
            }
            for(var balloon in this.balloonCityArray){
                TweenMax.killTweensOf(this.balloonCityArray[balloon]);
            }
            //bool for reduced motion
            //his.isReducedEndAnimation=true;

            this.winContainer.visible=false;
            this.skipped=false;
            this.isGameOver=false;
            this.uiReplay.visible=false;
            this.objsArray.forEach(hObj => {
                hObj.alpha = 1;
                hObj.interactiveChildren = true;
            });
            this.hogContainer.setUserInput(false);
            this.gameStarted = false; //Used for ? button logic.

            //Audio
            this.eventBus.dispatchEvent(new Event(this.EV_PLAY_MUSIC, this));            
        }

        public skip(){
            //Skip to the end of the card
            //console.log("Skipping to end");
            this.skipped=true;
            this.youWin();
        }

         public animate(deltaTime?:number):void{
            if(!this.isPlaying){
                this.isPlaying = true;
            }else{
                this.flameEmitter_1.update(deltaTime);
                this.flameEmitter_2.update(deltaTime);
                this.flameEmitter_3.update(deltaTime);
                //this.stopwatch.update(deltaTime);
                this.uiStopwatch.text = this.stopwatch.getCurrentTime().toString(TimeInfo.MINUTES | TimeInfo.SECONDS, ":", false);
                this.uiStopwatch.position.set(Math.round(83-this.uiStopwatch.width/2), 617); 
                this.rippleTilingLeft.tilePosition.x += 0.4;
                this.rippleTilingLeft.tilePosition.y += 4;
                this.rippleTilingRight.tilePosition.x += 0.4;
                this.rippleTilingRight.tilePosition.y += 4;
                this.rippleTilingCenter.tilePosition.x += 0.02;
                this.rippleTilingCenter.tilePosition.y += 1.95;

                if(this.blueButterfly.currentFrame>=369){
                    this.blueButterfly.stop();
                    this.blueButterflyTimeout--;
                    if(this.blueButterflyTimeout<=0){
                        this.blueButterfly.gotoAndPlay(0);
                        this.blueButterflyTimeout=1800;
                    }
                }
                if(this.yellowButterfly.currentFrame>=244){
                    this.yellowButterfly.stop();
                    this.yellowButterflyTimeout--;
                    if(this.yellowButterflyTimeout<=0){
                        this.yellowButterfly.gotoAndPlay(0);
                        this.yellowButterflyTimeout=1800;
                    }
                }
            }                        
        }
    }
}